export const BootcampReviews = [
  {
    bootcamp: "options-trading-bootcamp-with-abhishek-bansal-",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Tech Head",
          rating: 5,
          days: 18,
        },
        {
          name: "Aradhya",
          profession: "Data Analyst",
          rating: 4,
          days: 25,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Abhishek Bansal's Options Trading Bootcamp is exceptional! It equipped me with advanced options trading strategies.",
        "Expert guidance! This bootcamp provided practical skills for maximizing options trading profits.",
        "Game-changer! Thanks to this bootcamp, I now trade options with precision and success.",
      ],
    },
  },
  {
    bootcamp: "system-trading-bootcamp-with-abhishek-bansal",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Tech Head",
          rating: 5,
          days: 6,
        },
        {
          name: "Jyoti Dixit",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 21 },
      ],
      review: [
        "Abhishek Bansal's System Trading Bootcamp equipped me with robust trading systems. Highly practical!",
        "Invaluable strategies! This bootcamp taught me to develop and implement effective trading systems.",
        "Game-changer! Thanks to this bootcamp, my trading has become more systematic and profitable.",
      ],
    },
  },
  {
    bootcamp: "the-ultimate-bootcamp-for-intraday-&-scalping",
    reviews: {
      name: [
        {
          name: "Aman Gupta",
          profession: "Security Specialist",
          rating: 5,
          days: 4,
        },
        {
          name: "Ishita",
          profession: "Business Analyst",
          rating: 4,
          days: 12,
        },
        { name: "Raghav", profession: "Trader", rating: 5, days: 19 },
      ],
      review: [
        "The Ultimate Bootcamp for Intraday & Scalping gave me the edge I needed in fast-paced trading. Highly effective strategies!",
        "Incredible course! I now feel confident navigating intraday trading thanks to this bootcamp.",
        "Transformative experience! The techniques taught here are a game-changer for scalping.",
      ],
    },
  },
  {
    bootcamp: "ultimate-forex-trading-bootcamp---the-holy-grail-of-trading",
    reviews: {
      name: [
        {
          name: "Ansh Thakur",
          profession: "Secutiry Specialist",
          rating: 5,
          days: 7,
        },
        {
          name: "Ishika",
          profession: "Data Scientist",
          rating: 4,
          days: 14,
        },
        { name: "Rohan Patel", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "The Holy Grail of Trading indeed! This bootcamp unlocked a whole new level of success in forex for me.",
        "Invaluable insights! This bootcamp is a must for anyone serious about forex trading.",
        "Life-changing course! I'm now trading forex with confidence and clarity.",
      ],
    },
  },
  {
    bootcamp:
      "unique-and-ultimate--trading-psychology-bootcamp-by-rajesh-patra",
    reviews: {
      name: [
        {
          name: "Arnav",
          profession: "Software Engineer",
          rating: 5,
          days: 11,
        },
        {
          name: "Ishita",
          profession: "Business Analyst",
          rating: 4,
          days: 23,
        },
        { name: "Ashutosh", profession: "Trader", rating: 5, days: 29 },
      ],
      review: [
        "Rajesh Patra's Trading Psychology Bootcamp is a game-changer! Overcame emotional hurdles and became a disciplined trader.",
        "Eye-opening experience! Understanding the psychology behind trading was key to my success.",
        "Highly recommended! This bootcamp transformed my mindset and approach to trading.",
      ],
    },
  },
  {
    bootcamp: "workshop-on-intraday-trading-with--jagpreet-singh-narula",
    reviews: {
      name: [
        {
          name: "Aditya",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Geeta Batra",
          profession: "Orthopedic Surgeon",
          rating: 4,
          days: 16,
        },
        { name: "Dheeraj", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "Expert guidance! JAGPREET SINGH NARULA's bootcamp equipped me with practical intraday trading skills.",
        "Invaluable strategies! This bootcamp is a must for anyone serious about intraday trading.",
        "Game-changer! Thanks to this bootcamp, I now navigate intraday trading confidently.",
      ],
    },
  },
  {
    bootcamp: "learn-advance-swing-trading-with-prabhu-selvaraj",
    reviews: {
      name: [
        {
          name: "Arya",
          profession: "Security Specialist",
          rating: 5,
          days: 8,
        },
        {
          name: "Rakshita",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Tariq", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Next-level insights! Prabhu Selvaraj's bootcamp elevated my swing trading game.",
        "Incredible value! This bootcamp taught me to identify high-probability trade setups.",
        "Highly recommend! Thanks to this bootcamp, I'm maximizing profits with advanced swing trading techniques.",
      ],
    },
  },
  {
    bootcamp: "understanding-the-psychology-behind-successful-trading",
    reviews: {
      name: [
        {
          name: "Arsh",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Vanshika",
          profession: "Housewife",
          rating: 4,
          days: 13,
        },
        { name: "Tushar", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Eye-opening journey! Understanding trading psychology was pivotal to my long-term success.",
        "Mindset shift! This bootcamp gave me the tools to stay disciplined in volatile markets.",
        "Essential course! Highly recommend for traders serious about achieving success.",
      ],
    },
  },
  {
    bootcamp: "master-options-market-with-raju-mulchandani",
    reviews: {
      name: [
        {
          name: "Rohan Patel",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Pooja Gusain",
          profession: "Business Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Aman Jha", profession: "Trader", rating: 5, days: 20 },
      ],
      review: [
        "Raju Mulchandani's expertise shines in this bootcamp! I now navigate the options market with confidence.",
        "Invaluable insights! This bootcamp demystified options trading for me.",
        "Game-changer! Thanks to this bootcamp, I've mastered options trading techniques.",
      ],
    },
  },
  {
    bootcamp: "index-option-trading-with-jagpreet-singh-narula",
    reviews: {
      name: [
        {
          name: "Vivek",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Harshita",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Raghav", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Expert guidance! Jagpreet Singh Narula's bootcamp equipped me with practical skills for trading index options.",
        "Invaluable strategies! This bootcamp is a must for anyone serious about index option trading.",
        "Game-changer! Thanks to this bootcamp, I now navigate index options confidently.",
      ],
    },
  },
  {
    bootcamp: "intraday-trading-by-prabjot-singh",
    reviews: {
      name: [
        {
          name: "Advik",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Bhavya Verma",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Devansh", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Practical wisdom! Prabjot Singh's bootcamp provided me with actionable strategies for intraday trading.",
        "Incredible value! This bootcamp taught me how to thrive in fast-paced intraday markets.",
        "Highly recommend! Thanks to this bootcamp, I've honed my skills as an intraday trader.",
      ],
    },
  },
  {
    bootcamp: "mastering-executions-and-deployment-with-algotest",
    reviews: {
      name: [
        {
          name: "Ayushman",
          profession: "Security Specialist",
          rating: 5,
          days: 16,
        },
        {
          name: "Deepika",
          profession: "Financial Analyst",
          rating: 4,
          days: 21,
        },
        { name: "Ekansh", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Invaluable insights! This bootcamp helped me master executions and deployment in algorithmic trading.",
        "Expert guidance! Algotest's bootcamp provided practical techniques for successful trading execution.",
        "Game-changer! Thanks to this bootcamp, I now execute trades with precision and efficiency.",
      ],
    },
  },
  {
    bootcamp: "no-code-algo-trading-with-rajesh-patra",
    reviews: {
      name: [
        {
          name: "Harsh Shukla",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Naavya",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Hardik", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Revolutionary approach! Rajesh Patra's bootcamp made algorithmic trading accessible without code.",
        "Insightful journey! This bootcamp provided me with the tools to automate my trading strategies effortlessly.",
        "Highly recommend! Thanks to this bootcamp, I've embraced algorithmic trading without the need for coding.",
      ],
    },
  },
  {
    bootcamp: "master-forex-in-indian-market-with-nirlep-shah",
    reviews: {
      name: [
        {
          name: "Ishaan",
          profession: "Software Engineer",
          rating: 5,
          days: 12,
        },
        {
          name: "Vanshita",
          profession: "Financial Analyst",
          rating: 4,
          days: 19,
        },
        { name: "Kabir", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Nirlep's expertise shines in this bootcamp! I now navigate the Indian forex market with confidence.",
        "Invaluable insights! This bootcamp demystified forex trading in the Indian market for me.",
        "Game-changer! Thanks to this bootcamp, I've mastered forex trading techniques tailored for the Indian market.",
      ],
    },
  },
  {
    bootcamp: "ultimate-market-mastering-bootcamp",
    reviews: {
      name: [
        {
          name: "Lakshay",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Aditi",
          profession: "Financial Analyst",
          rating: 4,
          days: 10,
        },
        { name: "Tejas", profession: "Trader", rating: 5, days: 21 },
      ],
      review: [
        "Comprehensive insights! This bootcamp provided me with a holistic understanding of market dynamics.",
        "Expert guidance! The Ultimate Market Mastering Bootcamp equipped me with versatile trading skills.",
        "Game-changer! Thanks to this bootcamp, I now approach the market with confidence and clarity.",
      ],
    },
  },
  {
    bootcamp: "algo-trading-level-2-with-vikram-kashikar",
    reviews: {
      name: [
        {
          name: "Parth Garg",
          profession: "Software Engineer",
          rating: 5,
          days: 2,
        },
        {
          name: "Sneha",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Garv Bansal", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Vikram Kashikar's Algo Trading Level 2 bootcamp took my algorithmic trading skills to the next level. Highly recommend!",
        "Invaluable insights! This bootcamp provided advanced techniques for successful algorithmic trading.",
        "Game-changer! Thanks to this bootcamp, I now execute complex trading strategies with confidence.",
      ],
    },
  },
  {
    bootcamp: "angel-investing-with-honish-zaveri",
    reviews: {
      name: [
        {
          name: "Rishabh",
          profession: "Technical Author",
          rating: 5,
          days: 11,
        },
        {
          name: "Divya",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Nitin", profession: "Trader", rating: 5, days: 23 },
      ],
      review: [
        "Honish Zaveri's Angel Investing bootcamp provided me with the knowledge and tools to navigate the world of startup investments.",
        "Insightful journey! This bootcamp demystified angel investing and empowered me to make informed decisions.",
        "Highly recommend! Thanks to this bootcamp, I'm confidently exploring opportunities in the startup ecosystem.",
      ],
    },
  },
  {
    bootcamp: "master-price-action-with-ds-vibhute",
    reviews: {
      name: [
        {
          name: "Pranav",
          profession: "QA Specialist",
          rating: 5,
          days: 8,
        },
        {
          name: "Niharika",
          profession: "Financial Analyst",
          rating: 4,
          days: 13,
        },
        { name: "Pranit", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "DS Vibhute's Master Price Action bootcamp unlocked the power of price action trading for me. Truly eye-opening!",
        "Invaluable techniques! This bootcamp provided practical insights into reading price charts effectively.",
        "Game-changer! Thanks to this bootcamp, I now make trading decisions based on price action with precision.",
      ],
    },
  },
  {
    bootcamp: "forex-trading-bootcamp-with-muthukannan",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Sharvi",
          profession: "Financial Analyst",
          rating: 4,
          days: 13,
        },
        { name: "Akshay", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Muthukannan's Forex Trading bootcamp equipped me with the skills and knowledge to succeed in the forex market.",
        "Invaluable insights! This bootcamp demystified forex trading and provided actionable strategies.",
        "Highly recommend! Thanks to this bootcamp, I'm navigating the forex market with confidence.",
      ],
    },
  },
  {
    bootcamp: "master-markets-with-harmonic-trading-with-mr.-bk-",
    reviews: {
      name: [
        {
          name: "Saman",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Saanvi",
          profession: "IT Trainer",
          rating: 4,
          days: 14,
        },
        { name: "Pratyush Soni", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "Mr. BK's Master Markets with Harmonic Trading bootcamp provided me with a comprehensive understanding of harmonic trading techniques.",
        "Expert guidance! This bootcamp equipped me with practical skills for identifying harmonic patterns in the market.",
        "Game-changer! Thanks to this bootcamp, I now trade the markets with precision using harmonic trading strategies.",
      ],
    },
  },
  {
    bootcamp: "forex-trading-bootcamp-with-jawaad-hussain",
    reviews: {
      name: [
        {
          name: "Arav Gupta",
          profession: "Software Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Rashmi Desai",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Arnav", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Jawaad Hussain's Forex Trading Bootcamp equipped me with the skills and confidence to excel in the forex market.",
        "Invaluable insights! This bootcamp provided practical strategies for navigating the complexities of forex trading.",
        "Highly recommend! Thanks to this bootcamp, I'm trading forex with clarity and precision.",
      ],
    },
  },
  {
    bootcamp: "Master Hiral's Unique Setup",
    reviews: {
      name: [
        {
          name: "Rayaan",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Shivani",
          profession: "Housewife",
          rating: 4,
          days: 16,
        },
        { name: "Saksham", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Hiral Shah's Advanced Commodities Trading bootcamp provided me with expert insights into the world of commodities trading.",
        "Invaluable techniques! This bootcamp equipped me with practical skills for profiting from commodity markets.",
        "Game-changer! Thanks to this bootcamp, I now trade commodities with confidence.",
      ],
    },
  },
  {
    bootcamp: "price-action-investing",
    reviews: {
      name: [
        {
          name: "Siddharth",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Ramya Garg",
          profession: "Technical Author",
          rating: 4,
          days: 17,
        },
        { name: "Samarth", profession: "Trader", rating: 5, days: 29 },
      ],
      review: [
        "Price Action Investing unlocked a whole new world of trading for me. Highly practical and insightful!",
        "Invaluable wisdom! This bootcamp taught me how to read price action charts effectively and make informed investment decisions.",
        "Highly recommend! Thanks to this bootcamp, I've mastered the art of price action investing.",
      ],
    },
  },
  {
    bootcamp: "ultimate-options-trading-with-chirag-jain",
    reviews: {
      name: [
        {
          name: "Vedant",
          profession: "Software Engineer",
          rating: 5,
          days: 10,
        },
        {
          name: "Anu Kapoor",
          profession: "Financial Analyst",
          rating: 4,
          days: 21,
        },
        { name: "Utkarsh", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Chirag Jain's Ultimate Options Trading bootcamp provided me with a comprehensive understanding of options trading strategies.",
        "Expert guidance! This bootcamp equipped me with practical skills for maximizing profits and minimizing risks in options trading.",
        "Game-changer! Thanks to this bootcamp, I now trade options with confidence and precision.",
      ],
    },
  },
  {
    bootcamp: "ultimate-options-bootcamp-with-jasmin-malhotra-",
    reviews: {
      name: [
        {
          name: "Umang Gaur",
          profession: "Software Engineer",
          rating: 5,
          days: 3,
        },
        {
          name: "Kanika",
          profession: "Financial Analyst",
          rating: 4,
          days: 11,
        },
        { name: "Veer", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "Jasmin Malhotra's Ultimate Options Bootcamp is a game-changer! I now have a solid foundation in options trading.",
        "Invaluable insights! This bootcamp provided practical strategies for navigating the options market effectively.",
        "Highly recommend! Thanks to this bootcamp, I'm mastering options trading with ease.",
      ],
    },
  },
  {
    bootcamp: "mastery-forex-trading-with-abhinav-ranjan",
    reviews: {
      name: [
        {
          name: "Ryan",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Jasmine",
          profession: "QA Specialist",
          rating: 4,
          days: 12,
        },
        { name: "Samaksh", profession: "Trader", rating: 5, days: 23 },
      ],
      review: [
        "Abhinav Ranjan's Mastery Forex Trading bootcamp provided me with advanced techniques for achieving success in the forex market.",
        "Invaluable techniques! This bootcamp equipped me with practical skills for profiting from currency trading.",
        "Game-changer! Thanks to this bootcamp, I now trade forex with confidence and precision.",
      ],
    },
  },
  {
    bootcamp: "a-z-mastery-on-swing-trading-with-prabhu-selvaraj-",
    reviews: {
      name: [
        {
          name: "Sathvik",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Sharanya",
          profession: "Housewife",
          rating: 4,
          days: 13,
        },
        { name: "Ali Goni", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "Prabhu Selvaraj's A-Z Mastery on Swing Trading is a must-attend! It equipped me with a comprehensive understanding of swing trading.",
        "Invaluable insights! This bootcamp provided practical strategies for identifying and executing profitable swing trades.",
        "Highly recommend! Thanks to this bootcamp, I now trade with confidence and precision.",
      ],
    },
  },
  {
    bootcamp: "master-elliot-waves-with-ashutosh-bharadwaj-",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Security Specialist",
          rating: 5,
          days: 6,
        },
        {
          name: "Ishika",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Ahuja", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Ashutosh's Master Elliot Waves bootcamp is a game-changer! I now understand and apply Elliot Wave theory effectively.",
        "Expert guidance! This bootcamp equipped me with the skills to identify market trends and reversals using Elliot Waves.",
        "Invaluable insights! Thanks to this bootcamp, my trading accuracy has improved significantly.",
      ],
    },
  },
  {
    bootcamp: "ultimate-trading-with-chirag-jain",
    reviews: {
      name: [
        {
          name: "Arav",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Ishika",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Rohan", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "Chirag Jain's Ultimate Trading bootcamp is exceptional! It provided me with a solid foundation in various trading strategies.",
        "Highly practical! This bootcamp equipped me with the skills to trade confidently in different market conditions.",
        "Game-changer! Thanks to this bootcamp, I now approach trading with a well-rounded strategy.",
      ],
    },
  },
  {
    bootcamp:
      "combining-ichimoku-cloud,-rsi,-and-heikin-ashi-:-a-winning-strategy",
    reviews: {
      name: [
        {
          name: "Arnav",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Ishita",
          profession: "Housewife",
          rating: 4,
          days: 18,
        },
        { name: "Yogesh", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "This bootcamp is outstanding! Combining Ichimoku Cloud, RSI, and Heikin Ashi has transformed my trading approach.",
        "Invaluable techniques! This bootcamp provided a comprehensive strategy that works across different market conditions.",
        "Highly recommend! Thanks to this bootcamp, my trading success has skyrocketed.",
      ],
    },
  },
  {
    bootcamp:
      "combining-ichimoku-cloud,-rsi,-and-heikin-ashi:-winning-strategy",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "QA Specialist",
          rating: 5,
          days: 7,
        },
        {
          name: "Rashmika",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Arjun", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "This bootcamp is outstanding! Combining Ichimoku Cloud, RSI, and Heikin Ashi has transformed my trading strategy.",
        "Invaluable insights! This bootcamp provided a comprehensive approach to technical analysis.",
        "Highly recommend! Thanks to this bootcamp, my trading success has skyrocketed.",
      ],
    },
  },
  {
    bootcamp: "options-trading-with-kamalpreet",
    reviews: {
      name: [
        {
          name: "Rehaan",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Saanvi",
          profession: "Technical Author",
          rating: 4,
          days: 16,
        },
        { name: "Parth Arora", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "KamalPreet's Options Trading bootcamp is a must-attend for anyone serious about mastering options trading.",
        "Expert guidance! This bootcamp equipped me with practical strategies for maximizing profits and minimizing risks in options trading.",
        "Invaluable insights! Thanks to this bootcamp, I now trade options with confidence and precision.",
      ],
    },
  },
  {
    bootcamp: "super-algo-trading-course",
    reviews: {
      name: [
        {
          name: "Hitesh",
          profession: "Software Engineer",
          rating: 5,
          days: 15,
        },
        {
          name: "Ananya",
          profession: "Business Analyst",
          rating: 4,
          days: 25,
        },
        { name: "Tushar", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "The Super Algo Trading Course provided me with advanced techniques for automating my trading strategies.",
        "Invaluable insights! This bootcamp taught me how to develop and implement profitable algorithmic trading systems.",
        "Highly recommend! Thanks to this course, I'm now a proficient algorithmic trader.",
      ],
    },
  },
  {
    bootcamp: "hidden-treasure-of-commodity-trading",
    reviews: {
      name: [
        {
          name: "Ansh Sharma",
          profession: "Software Engineer",
          rating: 5,
          days: 18,
        },
        {
          name: "Yamini",
          profession: "Data Analyst",
          rating: 4,
          days: 23,
        },
        { name: "Rohan Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "The Hidden Treasure Of Commodity Trading bootcamp unlocked new opportunities for profit in the commodities market.",
        "Invaluable techniques! This bootcamp provided practical strategies for trading commodities effectively.",
        "Game-changer! Thanks to this bootcamp, I now trade commodities with confidence and success.",
      ],
    },
  },
  {
    bootcamp: "zero-to-hero-bootcamp-with-kamal-preet-singh",
    reviews: {
      name: [
        {
          name: "Pratham",
          profession: "Software Engineer",
          rating: 5,
          days: 16,
        },
        {
          name: "Vamika",
          profession: "Data Analyst",
          rating: 4,
          days: 25,
        },
        { name: "Utkarsh", profession: "Trader", rating: 5, days: 29 },
      ],
      review: [
        "Kamal Preet Singh's Zero to Hero Bootcamp transformed my trading journey! From a novice to confident trader in no time.",
        "Invaluable insights! This bootcamp provided a comprehensive foundation for successful trading.",
        "Highly recommend! Thanks to this bootcamp, I now trade with confidence and skill.",
      ],
    },
  },
  {
    bootcamp: "master-options-trading-with-dr.-bhika-waghmode",
    reviews: {
      name: [
        {
          name: "Umang",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Himanshi",
          profession: "Data Scientist",
          rating: 4,
          days: 19,
        },
        { name: "Tejas", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Dr. Bhika Waghmode's Master Options Trading bootcamp is exceptional! It equipped me with advanced options trading techniques.",
        "Expert guidance! This bootcamp provided practical strategies for maximizing profits in options trading.",
        "Game-changer! Thanks to this bootcamp, I now trade options with precision and success.",
      ],
    },
  },
  {
    bootcamp: "master-advanced-option-strategy-with-avirup-de-new",
    reviews: {
      name: [
        {
          name: "Amandeep",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Tejaswi",
          profession: "Housewife",
          rating: 4,
          days: 18,
        },
        { name: "Yuvraj", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Avirup De's Master Advanced Option Strategy bootcamp is a must-attend! It provided me with sophisticated options trading strategies.",
        "Invaluable techniques! This bootcamp equipped me with skills to navigate complex options trades confidently.",
        "Game-changer! Thanks to this bootcamp, my options trading has reached new heights.",
      ],
    },
  },
  {
    bootcamp: "master-advanced-option-strategy-with-avirup-De",
    reviews: {
      name: [
        {
          name: "Wazir",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Vanshika",
          profession: "Business Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Saksham", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Avirup De's Master Advanced Option Strategy bootcamp is a must-attend! It provided me with sophisticated options trading strategies.",
        "Invaluable techniques! This bootcamp equipped me with skills to navigate complex options trades confidently.",
        "Game-changer! Thanks to this bootcamp, my options trading has reached new heights.",
      ],
    },
  },
  {
    bootcamp: "master-advanced-option-strategy-with-avirup-de",
    reviews: {
      name: [
        {
          name: "Sarthak",
          profession: "QA Specialist",
          rating: 5,
          days: 6,
        },
        {
          name: "Sakshi",
          profession: "Application Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Samarth", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Avirup De's Master Advanced Option Strategy bootcamp is a must-attend! It provided me with sophisticated options trading strategies.",
        "Invaluable techniques! This bootcamp equipped me with skills to navigate complex options trades confidently.",
        "Game-changer! Thanks to this bootcamp, my options trading has reached new heights.",
      ],
    },
  },
  {
    bootcamp: "super 18-mentorship-program-with-hemant-jain",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "IT Consultant",
          rating: 5,
          days: 7,
        },
        {
          name: "Kanika",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Arnav", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Hemant Jain's Super 18 Mentorship Program provided me with personalized guidance and advanced trading insights.",
        "Invaluable mentorship! This program equipped me with strategies tailored to my trading style and goals.",
        "Highly recommend! Thanks to this mentorship, my trading performance has improved significantly.",
      ],
    },
  },
  {
    bootcamp: "crypto-currency-bootcamp-with-munish-batra",
    reviews: {
      name: [
        {
          name: "Arya",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Aradhya",
          profession: "Data Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Pratyush", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Munish Batra's Crypto Currency Bootcamp is a must for anyone looking to succeed in the crypto market.",
        "Invaluable insights! This bootcamp provided practical strategies for trading and investing in cryptocurrencies.",
        "Game-changer! Thanks to this bootcamp, I now navigate the crypto market with confidence.",
      ],
    },
  },
  {
    bootcamp: "nifty-scalping:-mastering-quick-trades-for-consistent-profits",
    reviews: {
      name: [
        {
          name: "Karan Grover",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Hitanhshi",
          profession: "Teacher",
          rating: 4,
          days: 16,
        },
        { name: "Daksh", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "The Option Chain Analysis bootcamp provided me with advanced techniques for mastering quick trades.",
        "Invaluable insights! This bootcamp taught me how to analyze option chains for consistent profits.",
        "Highly recommend! Thanks to this bootcamp, my trading accuracy and profitability have improved significantly.",
      ],
    },
  },
  {
    bootcamp: "gann-theory-workshop-",
    reviews: {
      name: [
        {
          name: "Dev Arora",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Lavanya",
          profession: "Professor",
          rating: 4,
          days: 14,
        },
        { name: "Utkarsh", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "The GANN Theory Workshop provided me with deep insights into market forecasting. Truly enlightening!",
        "Invaluable techniques! This workshop demystified GANN theory for practical trading applications.",
        "Highly recommend! Thanks to this workshop, I now apply GANN principles with confidence.",
      ],
    },
  },
  {
    bootcamp: "super-algo-trading-using-excel-with-vikram-kashikar",
    reviews: {
      name: [
        {
          name: "Garv",
          profession: "IT Consultant",
          rating: 5,
          days: 11,
        },
        {
          name: "Chhavi",
          profession: "Teacher",
          rating: 4,
          days: 18,
        },
        { name: "Raghav", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "Vikram Kashikar's Super Algo Trading using Excel bootcamp is a must-attend! It provided advanced techniques for Excel-based algorithmic trading.",
        "Invaluable insights! This bootcamp made algorithmic trading accessible through Excel.",
        "Highly recommend! Thanks to this bootcamp, I'm now proficient in algo trading using Excel.",
      ],
    },
  },
  {
    bootcamp: "algo-trading-using-CHATGPT-bootcamp-with-aseem-singhal",
    reviews: {
      name: [
        {
          name: "Karan Verma",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Radhika Apte",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Rohan", profession: "Technical Author", rating: 5, days: 24 },
      ],
      review: [
        "Aseem Singhal's Algo Trading Using ChatGPT bootcamp is revolutionary! Integrating AI into trading has never been easier.",
        "Invaluable techniques! This bootcamp provided practical applications of ChatGPT for trading automation.",
        "Highly recommend! Thanks to this bootcamp, I'm now leveraging AI to enhance my trading strategies.",
      ],
    },
  },
  {
    bootcamp: "stock-trading-bootcamp-for-women-with-jasmin-malhotra-",
    reviews: {
      name: [
        {
          name: "Om Jain",
          profession: "Software Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Radhika Apte",
          profession: "Financial Analyst",
          rating: 4,
          days: 19,
        },
        {
          name: "S.M. Sharan",
          profession: "Technical Author",
          rating: 5,
          days: 25,
        },
      ],
      review: [
        "Jasmin Malhotra's Stock Trading Bootcamp for Women empowered me with the skills and confidence to excel in trading.",
        "Invaluable insights! This bootcamp provided a supportive environment for women traders.",
        "Highly recommend! Thanks to this bootcamp, I'm now trading stocks with confidence and success.",
      ],
    },
  },
  {
    bootcamp: "trade-like-a-pro-with-raju-mulchandani",
    reviews: {
      name: [
        {
          name: "Varun",
          profession: "Software Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Radhika Apte",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Shaurya", profession: "IT Consultant", rating: 5, days: 24 },
      ],
      review: [
        "Raju Mulchandani's Trade like a pro bootcamp transformed my trading approach! I now trade like a professional.",
        "Invaluable insights! This bootcamp provided advanced trading techniques and strategies.",
        "Highly recommend! Thanks to this bootcamp, my trading skills have reached new heights.",
      ],
    },
  },
  {
    bootcam: "the-holy-grail-of-trading-with-balakrishna-",
    reviews: {
      name: [
        {
          name: "Kabir",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Radhika Apte",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Arshdeep", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Balakrishna's The Holy Grail of Trading bootcamp is truly transformative! It provided me with the ultimate trading strategies.",
        "Invaluable wisdom! This bootcamp demystified complex trading concepts for practical application.",
        "Game-changer! Thanks to this bootcamp, I'm achieving consistent trading success.",
      ],
    },
  },
  {
    bootcamp: "master-the-psychology-of-market-with-intraday-trading",
    reviews: {
      name: [
        {
          name: "Sameer",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Radhika Apte",
          profession: "Data Analyst",
          rating: 4,
          days: 10,
        },
        {
          name: "Sumanyu",
          profession: "Technical Author",
          rating: 5,
          days: 18,
        },
      ],
      review: [
        "This bootcamp is a must-attend! It provided me with the psychological tools to excel in intraday trading.",
        "Invaluable insights! This bootcamp helped me understand and master the psychology behind successful trading.",
        "Highly recommend! Thanks to this bootcamp, my intraday trading performance has significantly improved.",
      ],
    },
  },
  {
    bootcamp: "algo-trading-using-python-bootcamp-with-aseem-singhal",
    reviews: {
      name: [
        {
          name: "Vivek Tiwari",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Radhika Apte",
          profession: "Consultant",
          rating: 4,
          days: 11,
        },
        { name: "Vishal", profession: "Trader", rating: 5, days: 17 },
      ],
      review: [
        "Aseem Singhal's Algo Trading Using Python bootcamp is exceptional! It provided advanced techniques for Python-based algorithmic trading.",
        "Invaluable insights! This bootcamp made algorithmic trading accessible through Python programming.",
        "Highly recommend! Thanks to this bootcamp, I'm now proficient in algo trading using Python.",
      ],
    },
  },
];

export const MasterclassReviews = [
  {
    masterclass: "master-harmonic-trading-with-mr-bk--gz5zaximh",
    reviews: {
      name: [
        {
          name: "Bhuvan Ban",
          profession: "Security Engineer",
          rating: 5,
          days: 18,
        },
        {
          name: "Ayesha Khan",
          profession: "Financial Analyst",
          rating: 4,
          days: 25,
        },
        { name: "Rahul", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Mr. BK's Master Harmonic Trading masterclass was incredibly insightful! It provided a clear understanding of harmonic patterns.",
        "Highly recommend! This free masterclass gave me valuable techniques for identifying and trading harmonic setups.",
        "Fantastic session! Thanks to Mr. BK, I now have a solid foundation in harmonic trading.",
      ],
    },
  },
  {
    masterclass: "master-gann-theory-abhishek-bansal-su8bs9swa",
    reviews: {
      name: [
        {
          name: "Umesh Sikka",
          profession: "Software Engineer",
          rating: 5,
          days: 16,
        },
        {
          name: "Sakshi Batra",
          profession: "Blog Writer",
          rating: 4,
          days: 25,
        },
        { name: "Aryaveer", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Abhishek Bansal's Gann Theory masterclass was exceptional! It demystified complex concepts for practical use.",
        "Highly insightful! This session provided a comprehensive introduction to Gann Theory.",
        "Fantastic learning experience! Thanks to Abhishek, I now understand the basics of Gann Theory.",
      ],
    },
  },
  {
    masterclass: "tfu-x-algofox-trading-course-with-kushal-gu2j4w1go",
    reviews: {
      name: [
        {
          name: "Kushal",
          profession: "Technical Author",
          rating: 5,
          days: 17,
        },
        {
          name: "Lakshanya",
          profession: "Financial Analyst",
          rating: 4,
          days: 21,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Kushal's Algo Trading masterclass was outstanding! It provided practical insights into algorithmic trading.",
        "Highly recommend! This session gave me a solid foundation in algo trading with TFU X Algofox.",
        "Invaluable techniques! Thanks to Kushal, I now feel confident exploring algorithmic trading.",
      ],
    },
  },
  {
    masterclass: "the-ultimate-trading-course-cxu98c5y8",
    reviews: {
      name: [
        {
          name: "Arnav",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Kavita Singh",
          profession: "Financial Analyst",
          rating: 4,
          days: 11,
        },
        { name: "Yatharth", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "The Ultimate Trading Course masterclass was incredibly informative! It covered essential trading strategies and techniques.",
        "Highly recommend! This free session provided a great overview of successful trading practices.",
        "Fantastic insights! I left the masterclass with a clearer understanding of effective trading.",
      ],
    },
  },
  {
    masterclass: "tradewise--market-helpline--cusp52awd",
    reviews: {
      name: [
        {
          name: "Arya",
          profession: "Blog Writer",
          rating: 5,
          days: 5,
        },
        {
          name: "Sharanya",
          profession: "Financial Analyst",
          rating: 4,
          days: 19,
        },
        { name: "Nitesh", profession: "Trader", rating: 5, days: 21 },
      ],
      review: [
        "The Tradewise Market Helpline masterclass was incredibly helpful! It provided practical market insights and advice.",
        "Highly recommend! This session gave me valuable tips for navigating the markets successfully.",
        "Invaluable guidance! Thanks to this masterclass, I now approach the market with greater confidence.",
      ],
    },
  },
  {
    masterclass:
      "masterclass-on-options-trading-with-mr-kamal-preet-singh-lsyqgag38",
    reviews: {
      name: [
        {
          name: "Kanha",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Ridhi Sharma",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Nirlep", profession: "Trader", rating: 5, days: 23 },
      ],
      review: [
        "Mr. Kamal Preet Singh's OPTIONS Trading masterclass was exceptional! It provided a thorough introduction to options trading.",
        "Highly insightful! This session gave me practical strategies for trading options effectively.",
        "Fantastic learning experience! Thanks to Mr. Kamal Preet Singh, I now understand the basics of options trading.",
      ],
    },
  },
  {
    masterclass: "master-swing-trading-secrets-with-kavita-u2ipiwp9w",
    reviews: {
      name: [
        {
          name: "Arjun",
          profession: "IT Consultant",
          rating: 5,
          days: 5,
        },
        {
          name: "Anshika",
          profession: "Financial Analyst",
          rating: 4,
          days: 12,
        },
        { name: "Chirag", profession: "Trader", rating: 5, days: 21 },
      ],
      review: [
        "Kavita's Swing Trading masterclass was outstanding! It revealed key secrets to successful swing trading.",
        "Highly recommend! This session provided invaluable techniques for mastering swing trading.",
        "Fantastic learning experience! Thanks to Kavita, I now approach swing trading with greater confidence.",
      ],
    },
  },
  {
    masterclass: "algo-trading-level-2-with-vikram-kashikar-15u6bdgbq",
    reviews: {
      name: [
        {
          name: "Siddharth",
          profession: "Software Engineer",
          rating: 5,
          days: 3,
        },
        {
          name: "Kaveri Kapur",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Arjun", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Vikram Kashikar's Algo Trading Level 2 masterclass was a game-changer! It provided advanced insights into algorithmic trading.",
        "Highly recommend! This session equipped me with practical skills for complex algo trading strategies.",
        "Invaluable techniques! Thanks to Vikram, I now trade algorithms with greater confidence.",
      ],
    },
  },
  {
    masterclass: "ai-based-investing-with-dinesh-sqpcfnoar",
    reviews: {
      name: [
        {
          name: "Pranav",
          profession: "Security Specialist",
          rating: 5,
          days: 5,
        },
        {
          name: "Jyoti Dixit",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Rohan", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Dinesh's AI Based Investing masterclass was outstanding! It provided a clear understanding of integrating AI in investing.",
        "Invaluable insights! This session showed me how to leverage AI for smarter investment decisions.",
        "Highly recommend! Thanks to Dinesh, I now approach investing with an AI perspective.",
      ],
    },
  },
  {
    masterclass:
      "creating-massive-wealth-in-5-years-using-angel-investing-3mej3l3dx",
    reviews: {
      name: [
        {
          name: "Aarav",
          profession: "QA Specialist",
          rating: 5,
          days: 6,
        },
        {
          name: "Aradhna",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Arora", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "This masterclass was incredibly valuable! It provided a roadmap for creating wealth through angel investing.",
        "Invaluable strategies! This session showed me how to identify and invest in promising startups.",
        "Highly recommend! Thanks to this masterclass, I now have a clear wealth-building plan.",
      ],
    },
  },
  {
    masterclass: "creating-massive-wealth-in-5-years-with-anel-ii66ujcrt",
    reviews: {
      name: [
        {
          name: "Yogesh",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Yashita",
          profession: "Data Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Aditya Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "This masterclass was incredibly valuable! It provided a roadmap for creating wealth through angel investing.",
        "Invaluable strategies! This session showed me how to identify and invest in promising startups.",
        "Highly recommend! Thanks to this masterclass, I now have a clear wealth-building plan.",
      ],
    },
  },
  {
    masterclass: "stock-market-trading-with-rohit-ti5ut68db",
    reviews: {
      name: [
        {
          name: "Chirag",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Alia Advani",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Sumanyu", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Rohit's Stock Market Trading masterclass was exceptional! It offered essential strategies for successful trading.",
        "Highly practical! This session gave me valuable tips for navigating the stock market.",
        "Fantastic insights! Thanks to Rohit, I now trade stocks with greater confidence.",
      ],
    },
  },
  {
    masterclass:
      "masterclass-on-ichimoku-rsi-and-heikin-ashi--trading-setup-dr11ux7ug",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "QA Specialist",
          rating: 5,
          days: 9,
        },
        {
          name: "Deepika Goyal",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Kabir Singh", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "This masterclass provided cutting-edge techniques for advanced trading setups. Highly informative!",
        "Invaluable insights! This session showed me how to optimize my trading strategies for better results.",
        "Highly recommend! Thanks to this masterclass, my trading setup has become more sophisticated.",
      ],
    },
  },
  {
    masterclass:
      "the-art-of-becoming-profitable-with-intraday-trading-esp42hbgi",
    reviews: {
      name: [
        {
          name: "Karan",
          profession: "Software Engineer",
          rating: 5,
          days: 10,
        },
        {
          name: "Deepika Singh",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Nipun", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "This masterclass was a game-changer! It provided practical strategies for profitable intraday trading.",
        "Highly insightful! This session equipped me with the tools to succeed in intraday trading.",
        "Fantastic learning experience! Thanks to this masterclass, my intraday trading has improved significantly.",
      ],
    },
  },
  {
    masterclass:
      "masterclass-on-fundraising-through-sme-ipos-with-navin-tekwani-72pxsz5tv",
    reviews: {
      name: [
        {
          name: "Garv",
          profession: "QA Specialist",
          rating: 5,
          days: 3,
        },
        {
          name: "Ria Chaudhary",
          profession: "Financial Analyst",
          rating: 4,
          days: 10,
        },
        { name: "Ruhaan", profession: "Trader", rating: 5, days: 18 },
      ],
      review: [
        "Navin Tekwani's masterclass on SME IPOs was incredibly informative! It provided a comprehensive guide to fundraising.",
        "Highly practical! This session showed me how to leverage SME IPOs for business growth.",
        "Fantastic insights! Thanks to Navin, I now understand the intricacies of SME IPO fundraising.",
      ],
    },
  },

  {
    masterclass: "forex-trading-with-abhinav-ranjan-txkpqwx34",
    reviews: {
      name: [
        {
          name: "Parth",
          profession: "Software Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Priya",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Yash Pal", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Abhinav Ranjan's Forex Trading masterclass was exceptional! It provided valuable techniques for forex trading.",
        "Highly recommend! This session equipped me with the skills to navigate the forex market confidently.",
        "Invaluable insights! Thanks to Abhinav, my forex trading strategy is now more robust.",
      ],
    },
  },
  {
    masterclass:
      "masterclass-on-strategic-planning-lead-generation-and-branding-1x0t7iwqb",
    reviews: {
      name: [
        {
          name: "Yashvendra",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Lakshanya",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Arun Kumar", profession: "Trader", rating: 5, days: 23 },
      ],
      review: [
        "This masterclass was incredibly valuable! It provided actionable strategies for strategic planning, lead generation, and branding.",
        "Highly practical! This session showed me how to enhance my business's growth and visibility.",
        "Fantastic insights! Thanks to this masterclass, my strategic approach is now more effective.",
      ],
    },
  },
  {
    masterclass: "kamal-preet-swing-masterclass-webinar-h6tm6f4p9",
    reviews: {
      name: [
        {
          name: "Arvind",
          profession: "IT Consultant",
          rating: 5,
          days: 8,
        },
        {
          name: "Vanshika",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Kamal Preet's Swing Masterclass Webinar was exceptional! It provided advanced swing trading techniques.",
        "Highly insightful! This session equipped me with the skills to execute successful swing trades.",
        "Fantastic learning experience! Thanks to Kamal Preet, my swing trading has significantly improved.",
      ],
    },
  },
  {
    masterclass: "options-trading-masterclass-with-abhishek-bansal-h2yfwvzkz",
    reviews: {
      name: [
        {
          name: "Hemant",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Vamika",
          profession: "Financial Analyst",
          rating: 4,
          days: 12,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Abhishek Bansal's Options Trading masterclass was outstanding! It offered a deep dive into options trading strategies.",
        "Highly practical! This session gave me the tools to trade options effectively.",
        "Invaluable insights! Thanks to Abhishek, I now trade options with greater confidence.",
      ],
    },
  },
  {
    masterclass: "system-trading-masterclass-with-abhishek-bansal-ss4zu0h6x",
    reviews: {
      name: [
        {
          name: "Vivek Tiwari",
          profession: "Software Engineer",
          rating: 5,
          days: 2,
        },
        {
          name: "Arohi",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 29 },
      ],
      review: [
        "Abhishek Bansal's System Trading masterclass was incredibly informative! It provided practical insights into system trading.",
        "Highly recommend! This session showed me how to develop and implement trading systems.",
        "Fantastic learning experience! Thanks to Abhishek, my trading system is now more efficient.",
      ],
    },
  },
  {
    masterclass: "master-intraday-trading-with-ujjwal-ladha-09uwb69qt",
    reviews: {
      name: [
        {
          name: "Vikram",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Sonali Roy",
          profession: "Product Manager",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Ujjwal Ladha's Intraday Trading masterclass was exceptional! It provided practical strategies for intraday trading success.",
        "Highly practical! This session showed me how to improve my intraday trading performance.",
        "Fantastic insights! Thanks to Ujjwal, my intraday trading skills have significantly improved.",
      ],
    },
  },
  {
    masterclass: "become-a-professional-options-trader-with-jyoti-sn4ylifq6",
    reviews: {
      name: [
        {
          name: "Raghav",
          profession: "Product Manager",
          rating: 5,
          days: 7,
        },
        {
          name: "Vanshika",
          profession: "Software Developer",
          rating: 4,
          days: 13,
        },
        {
          name: "Raghav Patel",
          profession: "Technical Author",
          rating: 5,
          days: 28,
        },
      ],
      review: [
        "Jyoti's Options Trading masterclass was incredibly informative! It provided a solid foundation for professional options trading.",
        "Highly recommend! This session gave me the skills to trade options like a professional.",
        "Invaluable techniques! Thanks to Jyoti, my options trading has reached new heights.",
      ],
    },
  },
  {
    masterclass: "masterclass-on-forex-trading-with-jawaad-hussain-nj39jhbn6",
    reviews: {
      name: [
        {
          name: "Rahul",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Vanshita",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "Jawaad Hussain's Forex Trading masterclass was outstanding! It offered valuable insights into forex trading.",
        "Highly practical! This session equipped me with the tools to trade forex effectively.",
        "Fantastic learning experience! Thanks to Jawaad, my forex trading strategy is now more robust.",
      ],
    },
  },
  {
    masterclass: "master-btst-strategy-with-vinod-kumar-3io3v66qa",
    reviews: {
      name: [
        {
          name: "Sanjay",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Anshika",
          profession: "Financial Analyst",
          rating: 4,
          days: 13,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Vinod Kumar's Trading Strategy masterclass was incredibly valuable! It provided advanced trading strategies.",
        "Highly insightful! This session showed me how to refine my trading strategies for better results.",
        "Invaluable techniques! Thanks to Vinod, my trading approach is now more strategic and effective.",
      ],
    },
  },
  {
    masterclass: "algo-trading-masterclass-with-aseem-singhal--hedypfvhe",
    reviews: {
      name: [
        {
          name: "Dheeraj Batra",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Himani Chandra",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Aseem Singhal's Automated Trading in Python masterclass was exceptional! It provided clear, practical techniques for coding automated trading systems.",
        "Highly recommend! This session gave me a solid foundation in Python-based automated trading.",
        "Fantastic insights! Thanks to Aseem, I now feel confident in implementing automated trading strategies.",
      ],
    },
  },
  {
    masterclass: "options-trading-with-chirag-jain-q4cytvmuu",
    reviews: {
      name: [
        {
          name: "Lakshay",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Vartika Jha",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Chirag Jain's Options Trading masterclass was incredibly informative! It offered valuable strategies for options trading.",
        "Highly practical! This session equipped me with the skills to trade options successfully.",
        "Fantastic learning experience! Thanks to Chirag, my options trading has improved significantly.",
      ],
    },
  },
  {
    masterclass: "futures-and-options-trading-with-vikash-4d39muv87",
    reviews: {
      name: [
        {
          name: "Suryansh",
          profession: "Software Engineer",
          rating: 5,
          days: 3,
        },
        {
          name: "Kiara",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 21 },
      ],
      review: [
        "Vikash Bagaria's Options Trading masterclass was outstanding! It provided a comprehensive introduction to options trading.",
        "Highly insightful! This session gave me practical techniques for trading options effectively.",
        "Invaluable strategies! Thanks to Vikash, I now approach options trading with greater confidence.",
      ],
    },
  },
  {
    masterclass: "master-algo-trading-with-algotest-ak0lmv5gq",
    reviews: {
      name: [
        {
          name: "Kanav Singh",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Diksha",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 20 },
      ],
      review: [
        "The Master Algo Trading with Algotest masterclass was a game-changer! It provided advanced insights into algorithmic trading.",
        "Highly recommend! This session showed me how to optimize my trading strategies using Algotest.",
        "Invaluable techniques! Thanks to this masterclass, my algorithmic trading has become more efficient and profitable.",
      ],
    },
  },
  {
    masterclass: "master-market-highs-and-lows-with-harinder-d4d076712",
    reviews: {
      name: [
        {
          name: "Krish Pathak",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Disha",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Harinder's Master Market Highs and Lows masterclass was incredibly valuable! It provided key strategies for identifying market turning points.",
        "Highly practical! This session gave me the tools to trade market highs and lows effectively.",
        "Fantastic insights! Thanks to Harinder, my trading accuracy has significantly improved.",
      ],
    },
  },
  {
    masterclass:
      "learn-stock-market-and-introduction-to-derivates-with-jasmin-malhotra-2svn8l6o1",
    reviews: {
      name: [
        {
          name: "Zeeshan",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Jia Sanon",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "Jasmin Malhotra's Ultimate Options Masterclass was outstanding! It provided advanced strategies for options trading.",
        "Highly insightful! This session equipped me with the techniques to trade options like a pro.",
        "Fantastic learning experience! Thanks to Jasmin, my options trading skills have improved significantly.",
      ],
    },
  },
  {
    masterclass: "-the-psychology-of-price-action-trading-0dyxs3d8i",
    reviews: {
      name: [
        {
          name: "Zubair",
          profession: "Software Engineer",
          rating: 5,
          days: 3,
        },
        {
          name: "Jasmine",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "The Psychology of Price Action Trading masterclass was incredibly enlightening! It provided deep insights into the psychological aspects of trading.",
        "Highly recommend! This session showed me how to align my mindset with effective price action strategies.",
        "Invaluable wisdom! Thanks to this masterclass, I now approach price action trading with greater confidence and clarity.",
      ],
    },
  },
  {
    masterclass: "how-to-double-your-profit-with-commodity-trading-l1zx60xdl",
    reviews: {
      name: [
        {
          name: "Zeeshan",
          profession: "Software Engineer",
          rating: 5,
          days: 17,
        },
        {
          name: "Divya Bharti",
          profession: "Financial Analyst",
          rating: 4,
          days: 25,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "This masterclass was a game-changer! It provided practical strategies for significantly increasing profits in commodity trading.",
        "Highly insightful! This session gave me the tools to maximize my earnings from commodity trades.",
        "Invaluable techniques! Thanks to this masterclass, my commodity trading profits have doubled.",
      ],
    },
  },
  {
    masterclass: "intraday-scalping-with-manoj-g6v7m8oga",
    reviews: {
      name: [
        {
          name: "Dhruv",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Divya Anand",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        {
          name: "Raghav Patel",
          profession: "IT Consultant",
          rating: 5,
          days: 28,
        },
      ],
      review: [
        "Manoj Mishra's Intraday Scalping masterclass was exceptional! It provided practical strategies for effective scalping.",
        "Highly practical! This session gave me the skills to execute quick, profitable trades.",
        "Invaluable techniques! Thanks to Manoj, my intraday trading has become more efficient and profitable.",
      ],
    },
  },
  {
    masterclass: "index-option-trading-with-jagpreet-singh-narula-57nw7q3iv",
    reviews: {
      name: [
        {
          name: "Siddharth",
          profession: "Software Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Mehak Verma",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Dhruv Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Jagpreet Singh Narula's Index Options Trading masterclass was outstanding! It offered advanced strategies for trading index options.",
        "Highly insightful! This session equipped me with the techniques to maximize my profits in index options trading.",
        "Fantastic learning experience! Thanks to Jagpreet, my index options trading skills have significantly improved.",
      ],
    },
  },
  {
    masterclass: "stock-trading-for-women-1jmmkqnq2",
    reviews: {
      name: [
        {
          name: "Aarav",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Mansi",
          profession: "Financial Analyst",
          rating: 4,
          days: 19,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Jasmin Malhotra's Stock Trading masterclass for women was incredibly empowering! It provided essential skills for successful trading.",
        "Highly recommend! This session created a supportive environment for women to learn and excel in stock trading.",
        "Invaluable insights! Thanks to Jasmin, I now trade stocks with greater confidence and success.",
      ],
    },
  },
  {
    masterclass: "master-price-action-with-dattatray-deffhei84",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Rashmi",
          profession: "Financial Analyst",
          rating: 4,
          days: 13,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 19 },
      ],
      review: [
        "DS Vibhute's Master Price Action masterclass was exceptional! It provided deep insights into price action trading.",
        "Highly practical! This session gave me the tools to read and interpret price movements effectively.",
        "Fantastic techniques! Thanks to DS Vibhute, my price action trading has improved significantly.",
      ],
    },
  },
  {
    masterclass: "algo-trading-with-vikram-kashikar-21e0a0mow",
    reviews: {
      name: [
        {
          name: "Tejas",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Raveena",
          profession: "Financial Analyst",
          rating: 4,
          days: 12,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 20 },
      ],
      review: [
        "Vikram Kashikar's Algo Trading using Excel masterclass was outstanding! It provided practical insights into algorithmic trading using Excel.",
        "Highly practical! This session equipped me with the skills to develop and implement trading algorithms in Excel.",
        "Fantastic learning experience! Thanks to Vikram, my algo trading with Excel has become more efficient and effective.",
      ],
    },
  },
  {
    masterclass: "algo-trading-conclave-1n8w49iqi",
    reviews: {
      name: [
        {
          name: "Prem Shankar",
          profession: "Technical Author",
          rating: 5,
          days: 7,
        },
        {
          name: "Sonali",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "The Algo Trading Conclave was incredibly informative! It provided cutting-edge insights into algorithmic trading.",
        "Highly recommend! This session offered practical techniques for enhancing my trading algorithms.",
        "Fantastic experience! Thanks to this conclave, my understanding of algo trading has greatly improved.",
      ],
    },
  },
  {
    masterclass: "option-trading-conclave-0tc8nlimn",
    reviews: {
      name: [
        {
          name: "Om Tiwari",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Kriti Arya",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "The Option Trading Conclave was outstanding! It offered advanced strategies for options trading.",
        "Highly practical! This session equipped me with the skills to trade options profitably.",
        "Fantastic insights! Thanks to this conclave, my options trading has significantly improved.",
      ],
    },
  },
  {
    masterclass: "the-holy-grail-of-trading-with-balakrishna--5wkhmpa7h",
    reviews: {
      name: [
        {
          name: "Raghav Patel",
          profession: "Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Kritika",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Balakrishna's Holy Grail of Trading masterclass was exceptional! It revealed powerful trading strategies.",
        "Highly insightful! This session gave me the tools to achieve consistent trading success.",
        "Invaluable techniques! Thanks to Balakrishna, my trading strategy is now more effective.",
      ],
    },
  },
  {
    masterclass: "masterclass-on-elliot-waves-with-ashutosh-bhardwaj-wuws931mt",
    reviews: {
      name: [
        {
          name: "Prithviraj",
          profession: "Software Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Bhavi Gupta",
          profession: "Financial Analyst",
          rating: 4,
          days: 17,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 26 },
      ],
      review: [
        "Ashutosh Bhardwaj's Elliot Waves masterclass was incredibly valuable! It provided deep insights into wave theory.",
        "Highly recommend! This session gave me practical techniques for applying Elliot Waves in trading.",
        "Invaluable learning! Thanks to Ashutosh, my understanding of market waves has greatly improved.",
      ],
    },
  },
  {
    masterclass: "masterclass-on-swing-trading-by-hemant-jain-dyehm87gn",
    reviews: {
      name: [
        {
          name: "Virat",
          profession: "Software Engineer",
          rating: 5,
          days: 6,
        },
        {
          name: "Pooja",
          profession: "Technical Author",
          rating: 4,
          days: 18,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "This Swing Trading masterclass was exceptional! It offered powerful strategies for successful swing trading.",
        "Highly practical! This session provided invaluable techniques for mastering swing trades.",
        "Fantastic insights! Thanks to this masterclass, my swing trading skills are now top-notch.",
      ],
    },
  },
  {
    masterclass: "masterclass-on-option-strategy-with-avirup-de-ism3fw78z",
    reviews: {
      name: [
        {
          name: "Rohit",
          profession: "Software Engineer",
          rating: 5,
          days: 4,
        },
        {
          name: "Kavya",
          profession: "Financial Analyst",
          rating: 4,
          days: 12,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 22 },
      ],
      review: [
        "Avirup De's Option Strategy masterclass was outstanding! It provided advanced options trading strategies.",
        "Highly insightful! This session equipped me with the tools to optimize my options trading.",
        "Invaluable techniques! Thanks to Avirup, my options trading strategies are now more effective.",
      ],
    },
  },
  {
    masterclass:
      "algoxperience-masterclass-transforming-traders-in-6-days-9z91cy6ey",
    reviews: {
      name: [
        {
          name: "Suryakumar",
          profession: "Software Engineer",
          rating: 5,
          days: 18,
        },
        {
          name: "Sneha",
          profession: "Financial Analyst",
          rating: 4,
          days: 11,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "The AlgoXperience masterclass was a game-changer! It transformed my trading approach in just 6 days.",
        "Highly recommend! This intensive session provided practical techniques for successful algo trading.",
        "Fantastic experience! Thanks to AlgoXperience, my trading performance has significantly improved.",
      ],
    },
  },
  {
    masterclass:
      "swing-trading-mentorship-program-with-mr-kamal-preet-singh-54ois0rvv",
    reviews: {
      name: [
        {
          name: "Yatharth",
          profession: "Software Engineer",
          rating: 5,
          days: 16,
        },
        {
          name: "Shivani",
          profession: "Financial Analyst",
          rating: 4,
          days: 20,
        },
        {
          name: "Raghav Patel",
          profession: "Technical Author",
          rating: 5,
          days: 28,
        },
      ],
      review: [
        "Mr. Kamal Preet Singh's Swing Trading masterclass was incredibly informative! It offered advanced swing trading techniques.",
        "Highly practical! This session gave me the skills to execute successful swing trades.",
        "Fantastic insights! Thanks to Kamal Preet, my swing trading has greatly improved.",
      ],
    },
  },
  {
    masterclass: "option-selling-masterclass-with-pankaj-sahu-fxhn7jue3",
    reviews: {
      name: [
        {
          name: "Hemang",
          profession: "Software Engineer",
          rating: 5,
          days: 3,
        },
        {
          name: "Palak",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Pankaj Sahu's Option Selling masterclass was outstanding! It provided practical strategies for profitable option selling.",
        "Highly recommend! This session equipped me with the tools to maximize my option selling profits.",
        "Invaluable techniques! Thanks to Pankaj, my option selling skills are now more effective.",
      ],
    },
  },
  {
    masterclass: "master-forex-in-indian-market-with-nirlep-9ep7ss0ug",
    reviews: {
      name: [
        {
          name: "Nitesh",
          profession: "Software Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Shreya",
          profession: "Business Analyst",
          rating: 4,
          days: 15,
        },
        {
          name: "Gitanshu",
          profession: "Sales Executive",
          rating: 5,
          days: 23,
        },
      ],
      review: [
        "Nirlep's expertise shines in this bootcamp! I now navigate the Indian forex market with confidence.",
        "Invaluable insights! This bootcamp demystified forex trading in the Indian market for me.",
        "Game-changer! Thanks to this bootcamp, I've mastered forex trading techniques tailored for the Indian market.",
      ],
    },
  },
  {
    masterclass:
      "masterclass-on-intraday-trading-with-jagpreet-singh-narula-4h8jq0m25",
    reviews: {
      name: [
        {
          name: "Vivaan",
          profession: "Businessman",
          rating: 5,
          days: 6,
        },
        {
          name: "Parineeti",
          profession: "Business Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 24 },
      ],
      review: [
        "Jagpreet Singh Narula's Intraday Trading masterclass was incredibly valuable! It provided practical strategies for intraday trading.",
        "Highly recommend! This session gave me the tools to improve my intraday trading performance.",
        "Invaluable insights! Thanks to Jagpreet, my intraday trading has significantly improved.",
      ],
    },
  },
  {
    masterclass: "unlocking-profits-and-consistency-in-swing-trading-rruvs9zny",
    reviews: {
      name: [
        {
          name: "Ashutosh",
          profession: "Electronics Engineer",
          rating: 5,
          days: 10,
        },
        {
          name: "Priyanka",
          profession: "Financial Analyst",
          rating: 4,
          days: 18,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 25 },
      ],
      review: [
        "This masterclass was a game-changer! It offered strategies for achieving consistent profits in swing trading.",
        "Highly insightful! This session equipped me with the techniques for successful swing trades.",
        "Fantastic learning experience! Thanks to this masterclass, my swing trading profits are more consistent.",
      ],
    },
  },
  {
    masterclass: "options-trading-with-raju-mulchandani-s8p1f2coi",
    reviews: {
      name: [
        {
          name: "Kushal",
          profession: "Mechanical Engineer",
          rating: 5,
          days: 5,
        },
        {
          name: "Yami Gautam",
          profession: "Financial Analyst",
          rating: 4,
          days: 12,
        },
        {
          name: "Raghav Patel",
          profession: "Product Manager",
          rating: 5,
          days: 26,
        },
      ],
      review: [
        "Raju Mulchandani's Options Trading masterclass was outstanding! It provided advanced options trading strategies.",
        "Highly practical! This session gave me the tools to trade options effectively.",
        "Invaluable techniques! Thanks to Raju, my options trading skills are now more refined.",
      ],
    },
  },
  {
    masterclass: "angel-investing-with-harmanbeer-singh-51umgdkkx",
    reviews: {
      name: [
        {
          name: "Kushal",
          profession: "Account Manager",
          rating: 5,
          days: 4,
        },
        {
          name: "Yamini",
          profession: "Financial Analyst",
          rating: 4,
          days: 15,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Honish Zaveri's Angel Investing masterclass was incredibly informative! It offered valuable insights into angel investing.",
        "Highly recommend! This session provided practical techniques for identifying and investing in startups.",
        "Fantastic learning experience! Thanks to Honish, I now approach angel investing with greater confidence.",
      ],
    },
  },
  {
    masterclass: "no-code-algo-trading-by-rajesh-sir--kxa835ogf",
    reviews: {
      name: [
        {
          name: "Harman",
          profession: "Software Engineer",
          rating: 5,
          days: 2,
        },
        {
          name: "Priya Desai",
          profession: "Financial Analyst",
          rating: 4,
          days: 11,
        },
        { name: "Sparsh", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "Rajesh Patra's No Code Algo Trading masterclass was exceptional! It provided practical techniques for no-code algorithmic trading.",
        "Highly practical! This session equipped me with the skills to develop algo trading systems without coding.",
        "Invaluable insights! Thanks to Rajesh, my algo trading approach is now more accessible and efficient.",
      ],
    },
  },
  {
    masterclass: "master-options-market-with-raju-mulchandani-gn10dr3i3",
    reviews: {
      name: [
        {
          name: "Dev Anand",
          profession: "Software Developer",
          rating: 5,
          days: 5,
        },
        {
          name: "Parnika",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Raju Mulchandani's Options Market masterclass was outstanding! It offered advanced strategies for options trading.",
        "Highly insightful! This session gave me the tools to master the options market.",
        "Fantastic learning experience! Thanks to Raju, my options trading skills have greatly improved.",
      ],
    },
  },
  {
    masterclass: "forex-trading-masterclass-with-muthukannan-rummwbyhv",
    reviews: {
      name: [
        {
          name: "Aman Gupta",
          profession: "Backend Engineer",
          rating: 5,
          days: 7,
        },
        {
          name: "Anshika",
          profession: "Financial Analyst",
          rating: 4,
          days: 13,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Muthukannan's Forex Trading masterclass was exceptional! It provided valuable techniques for successful forex trading.",
        "Highly practical! This session equipped me with the skills to navigate the forex market effectively.",
        "Invaluable insights! Thanks to Muthukannan, my forex trading strategy is now more robust.",
      ],
    },
  },
  {
    masterclass:
      "unlock-the-secrets-to-wealth-creation-think-and-grow-like-an-hni-xoukq3qam",
    reviews: {
      name: [
        {
          name: "Anupam",
          profession: "Frontend Engineer",
          rating: 5,
          days: 8,
        },
        {
          name: "Vanshita",
          profession: "Financial Analyst",
          rating: 4,
          days: 14,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 28 },
      ],
      review: [
        "This masterclass was incredibly valuable! It revealed powerful strategies for wealth creation and thinking like an HNI.",
        "Highly recommend! This session provided practical techniques for building and preserving wealth.",
        "Fantastic insights! Thanks to this masterclass, my approach to wealth creation is more strategic.",
      ],
    },
  },
  {
    masterclass: "crypto-currency-masterclass-with-munish-batra-s74xvbhia",
    reviews: {
      name: [
        {
          name: "Arnav Singla",
          profession: "Sr.Software Engineer",
          rating: 5,
          days: 9,
        },
        {
          name: "Lavanya",
          profession: "Financial Analyst",
          rating: 4,
          days: 16,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 23 },
      ],
      review: [
        "Munish Batra's Cryptocurrency masterclass was outstanding! It offered valuable insights into cryptocurrency trading.",
        "Highly practical! This session provided techniques for navigating the crypto market effectively.",
        "Fantastic learning experience! Thanks to Munish, my cryptocurrency trading strategy is now more robust.",
      ],
    },
  },
  {
    masterclass: "algo-trading-using-chatgpt-with-aseem-singhal--xgs5jtgx2",
    reviews: {
      name: [
        {
          name: "Amit Shah",
          profession: "Electronics Engineer",
          rating: 5,
          days: 17,
        },
        {
          name: "Rashmika",
          profession: "Financial Analyst",
          rating: 4,
          days: 20,
        },
        { name: "Raghav Patel", profession: "Trader", rating: 5, days: 27 },
      ],
      review: [
        "Aseem Singhal's Algo Trading Using ChatGPT masterclass was a game-changer! It provided advanced techniques for using AI in algo trading.",
        "Highly insightful! This session showed me how to leverage ChatGPT for developing trading algorithms.",
        "Invaluable strategies! Thanks to Aseem, my approach to algo trading is now more innovative and efficient.",
      ],
    },
  },
];
